/* eslint-disable import/no-extraneous-dependencies */
import { displayToasts } from "../Helpers/displayAppToast";
import { getCommonAPIHeaders, getProgramFromUrl } from "../Helpers/utils";
import { PROGRAM_SPECIFIC_NAMES } from "../Helpers/constants";

export const getPartnerRegistrationTemplate = async (
  templateName: any,
  isAuthenticated = false,
) => {
  const endpoint = isAuthenticated
    ? window?.partnerRegistrationConfig?.REACT_APP_GET_AUTH_TEMPLATE_ENDPOINT
    : window?.partnerRegistrationConfig?.REACT_APP_GET_TEMPLATE_ENDPOINT;

  const submitUrl = `${window?.partnerRegistrationConfig?.REACT_APP_API_URL}${endpoint}${templateName}`;
  const headers = getCommonAPIHeaders(isAuthenticated);
  try {
    const response: any = await fetch(submitUrl, { headers });
    if (response.ok) {
      const data = await response.json();
      return { status: response.status, data };
    }
    return { status: response.status, data: {} };
  } catch {
    return { status: 500, data: {} };
  }
};

export const getStates = async (country: string) => {
  const headers = getCommonAPIHeaders();
  const url = `${window?.partnerRegistrationConfig?.REACT_APP_API_URL}/api/v1/DXP/country/${country}/states`;
  try {
    const response = await fetch(url, { headers });
    if (response.ok) {
      const data = await response.json();
      return { status: 1, response: data };
    }
    const error = await response.json();
    return { status: 0, response: error };
  } catch {
    return { status: 0, response: "something went wrong" };
  }
};

export const findPartnerEmail = async (email: any, _programType: string) => {
  const headers = new Headers();
  headers.append("x-api-key", "exchange_spr");
  const program: any = getProgramFromUrl();

  const partnerSearchEndpoint =
    PROGRAM_SPECIFIC_NAMES[program].endpoints.findPartnerUrl;

  const findPartnerUrl = `${partnerSearchEndpoint}${encodeURIComponent(email.trim())}`;

  try {
    const response = await fetch(findPartnerUrl, { headers });
    if (response.ok) {
      const data = await response.json();
      return { status: 1, response: data };
    }
    const error = await response.json();
    return { status: 0, response: error };
  } catch {
    return { status: 0, response: "something went wrong" };
  }
};

export const saveLoginHistory = async (
  programType: string,
  contactId: string,
) => {
  let result = {};
  const headers = getCommonAPIHeaders();
  const saveHistoryUrl = `${
    window?.partnerRegistrationConfig?.REACT_APP_API_URL
  }/api/v1/${programType.toUpperCase()}/login-history/contact/${contactId}`;
  const response = await fetch(saveHistoryUrl, { headers, method: "POST" });
  if (response.ok) {
    result = { status: 1, message: "Login History Save Successfully." };
  } else {
    const error = await response.json();
    if (error?.message) {
      displayToasts({
        type: "error",
        text: error?.message,
        autoClose: true,
      });
    } else {
      displayToasts({
        type: "error",
        text: "Something Went Wrong",
        autoClose: true,
      });
    }
    result = { status: 0, message: "something went wrong" };
  }

  return result;
};

export const saveRegistrationForm = async (programType: string, body: any) => {
  let result = {};
  const headers = getCommonAPIHeaders();
  const saveHistoryUrl = `${
    window?.partnerRegistrationConfig?.REACT_APP_API_URL
  }/api/v1/${programType.toUpperCase()}/partner/register`;
  try {
    const response = await fetch(saveHistoryUrl, {
      headers,
      method: "POST",
      body: JSON.stringify(body),
    });
    if (response.ok) {
      const data = await response.json();
      result = { status: 1, message: "Saved Successfully", data };
    } else {
      const error = await response.json();
      let message = "something went wrong";
      if (error?.message) {
        message = error?.message;
        displayToasts({
          type: "error",
          text: error?.message,
          autoClose: true,
        });
      } else {
        displayToasts({
          type: "error",
          text: "Something Went Wrong",
          autoClose: true,
        });
      }
      result = { status: 0, message };
    }
  } catch {
    displayToasts({
      type: "error",
      text: "Something Went Wrong",
      autoClose: true,
    });
    result = { status: 0, message: "something went wrong" };
  }

  return result;
};

export const getPartnerRegistrationDetails = async (
  programType: string,
  accountId: any,
) => {
  let result = {};
  const headers = getCommonAPIHeaders();
  const url = `${
    window?.partnerRegistrationConfig?.REACT_APP_API_URL
  }/api/v1/${programType.toUpperCase()}/partner/${accountId}`;
  const response = await fetch(url, {
    headers,
    method: "GET",
  });
  if (response.ok) {
    const data = await response.json();
    // Set agreeToTos true only when personalInfo contains country (e.g. Continue Registration)
    if (data?.personalInfo && data?.personalInfo?.country) {
      data.personalInfo.agreeToTos = true;
    }
    result = { status: 1, data };
  } else {
    const error = await response.json();
    if (error?.message) {
      displayToasts({
        type: "error",
        text: error?.message,
        autoClose: true,
      });
    }
    result = { status: 0, message: "something went wrong" };
  }

  return result;
};

export const getAffiliatedCompany = async (
  programType: string,
  searchQuery: string,
) => {
  let result = {};
  const headers = getCommonAPIHeaders();
  const url = `${
    window?.partnerRegistrationConfig?.REACT_APP_API_URL
  }/api/v1/${programType.toUpperCase()}/partner/lookup?search=${encodeURIComponent(searchQuery)}`;
  const response = await fetch(url, {
    headers,
    method: "GET",
  });
  if (response.ok) {
    const data = await response.json();
    result = {
      status: 1,
      data: data.accounts,
    };
  } else {
    const error = await response.json();
    if (error?.message) {
      displayToasts({
        type: "error",
        text: error?.message,
        autoClose: true,
      });
    }
    result = { status: 0, message: "something went wrong" };
  }

  return result;
};

export const sendTermsAndConditions = async (programType: string) => {
  const submitUrl = `${
    window?.partnerRegistrationConfig?.REACT_APP_API_URL
  }/v1/${programType.toUpperCase()}/terms`;
  const headers = getCommonAPIHeaders();
  const response = await fetch(submitUrl, { headers, method: "PUT" });

  if (response.ok) {
    return { status: 1 };
  }
  const error = await response.json();
  if (error?.message) {
    return { status: 0, response: error?.message };
  }
  displayToasts({
    type: "error",
    text: "Something Went Wrong",
    autoClose: true,
  });
  return { status: 0 };
};
